export const Stack = ({ children }: any) => {
    return <div className='flex flex-col gap-8'>{children}</div>
}
